import React, { useState, useEffect } from 'react';
import { Search, Bell, HelpCircle, User } from 'lucide-react';
import { cn } from '../../lib/utils';
import { Breadcrumbs } from './Breadcrumbs';
import { EnvironmentBadge } from '../ui/environment-badge';
import { isAhaComplete, subscribe } from '../../data/demoStore';

export function TopBar() {
    const [aha, setAha] = useState(isAhaComplete());

    useEffect(() => {
        return subscribe(() => {
            setAha(isAhaComplete());
        });
    }, []);
    return (
        <header className="sticky top-0 z-30 flex h-14 items-center gap-4 border-b bg-background px-6 shadow-sm" role="banner" aria-label="Top navigation bar">
            {/* Left: Breadcrumbs & Context */}
            <div className="flex-1 flex items-center gap-4 overflow-hidden">
                <Breadcrumbs />
            </div>

            {/* Center: Search (only shown post-aha) */}
            {aha && (
                <div className="w-full max-w-md hidden md:flex relative" role="search" aria-label="Global search">
                    <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" aria-hidden="true" />
                    <input
                        type="search"
                        placeholder="Search resources, cases, or policies (Cmd+K)"
                        aria-label="Search resources, cases, or policies"
                        className="flex h-9 w-full rounded-md border border-input bg-background pl-9 pr-3 text-sm ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50"
                    />
                </div>
            )}

            {/* Right: Actions & Profile */}
            <div className="flex items-center gap-2 pl-4">
                {/* Env Indicator */}
                <EnvironmentBadge environment="demo" className="hidden lg:flex mr-2" />

                <button className="relative rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors">
                    <Bell className="h-4 w-4" />
                    <span className="absolute top-1.5 right-1.5 h-2 w-2 rounded-full bg-destructive border border-background" />
                    <span className="sr-only">Notifications</span>
                </button>

                <button className="rounded-md p-2 text-muted-foreground hover:bg-accent hover:text-accent-foreground transition-colors">
                    <HelpCircle className="h-4 w-4" />
                    <span className="sr-only">Help</span>
                </button>

                <div className="h-6 w-px bg-border mx-2" />

                <div className="flex items-center gap-3">
                    <div className="hidden text-right md:block">
                        <p className="text-sm font-medium leading-none">Admin User</p>
                        <p className="text-xs text-muted-foreground">admin@vedaya.ai</p>
                    </div>
                    <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center border border-primary/20 text-primary">
                        <User className="h-4 w-4" />
                    </div>
                </div>
            </div>
        </header>
    );
}
